import styled from 'styled-components';

export const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 62px;
    padding: 16px 32px;
    background: transparent;
    box-sizing: border-box;
`;

export const HeaderText = styled.div`
    font-family: 'Krona One', sans-serif;
    color: inherit;
    cursor: default;
    user-select: none;
    font-size: 12px;

    @media (min-width: 480px) {
        font-size: 18px;
    }
`;
